export default "__VITE_ASSET__CUnnPTwm__"